import { render, staticRenderFns } from "./InstructionDatatable.vue?vue&type=template&id=39baa468"
import script from "./InstructionDatatable.vue?vue&type=script&lang=js"
export * from "./InstructionDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports